import React from 'react';
import './Button.css';

/**
 * Button Component
 * Versatile button with multiple variants, sizes, and icon support
 * 
 * @param {ReactNode} children - Button content
 * @param {string} variant - 'primary', 'secondary', 'outline', 'danger', 'success', 'ghost'
 * @param {string} size - 'small', 'medium', 'large'
 * @param {string} icon - FontAwesome icon class (e.g., 'fa-arrow-right')
 * @param {string} iconPosition - 'left' or 'right'
 * @param {function} onClick - Click handler
 * @param {boolean} disabled - Disabled state
 * @param {boolean} fullWidth - Full width of container
 * @param {string} type - 'button', 'submit', 'reset'
 * @param {string} className - Additional CSS classes
 */
const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  icon = null,
  iconPosition = 'left',
  onClick,
  disabled = false,
  fullWidth = false,
  type = 'button',
  className = ''
}) => {
  const buttonClasses = [
    'btn',
    `btn-${variant}`,
    `btn-${size}`,
    fullWidth && 'btn-full-width',
    icon && !children && 'btn-icon-only',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && iconPosition === 'left' && <i className={`fas ${icon}`}></i>}
      {children && <span className="btn-text">{children}</span>}
      {icon && iconPosition === 'right' && <i className={`fas ${icon}`}></i>}
    </button>
  );
};

export default Button;